import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledDunningsSitewideBanner = styled(Flex)<{ isLastPaymentFailedWarning?: boolean }>`
    background: ${({ isLastPaymentFailedWarning }) =>
        isLastPaymentFailedWarning ? colorsPalettes.red[100] : colorsPalettes.yellow[100]};
    border-radius: 6px;
    padding: 4px 12px 4px 16px;
    gap: 16px;
    justify-content: center;
    align-items: center;
    height: 48px;
`;
